export default "<ion-item *ngFor=\"let item of cates\" lines=\"none\" (click)=\"selected(item)\">\n  <ion-label>{{item.name}}</ion-label>\n</ion-item>";